import styled, { withTheme } from 'styled-components';

const HiddenLgUp = styled.div`
  width: 100%;
  ${(props) => props.theme.breakpoints.up('lg')} {
    display: none;
  }
`;

export default withTheme(HiddenLgUp);
